import Loadable from "react-loadable";
import * as React from "react";

import { LoadingIndicator } from "../../shared/components";

export default Loadable({
  loader: () => import("./App"),
  loading: () => React.createElement(LoadingIndicator),
});
